export const editorialBoard = Object.freeze({ corporationPlus: 0, corporationPlusFstec: 1})
